ui-cms-realestate-surrounding-places {
  margin-top: 10px;

  .ui-headline {
    margin-top: 25px;
  }
}
